(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aito-featured"] && !Shopify.designMode) return;
  try {
    
  /**
   * 漸進增強：有 fetch 就 AJAX 加入購物車，無就照原本 form POST 去 /cart/add。
   * 純 vanilla，無外部 library。
   */
  (function () {
    function onDone(button, label) {
      if (!button) return;
      var original = button.getAttribute('data-aito-original');
      if (original === null) {
        original = button.textContent;
        button.setAttribute('data-aito-original', original);
      }
      button.textContent = label;
      button.classList.add('is-done');
      window.setTimeout(function () {
        button.textContent = original;
        button.classList.remove('is-done');
        button.disabled = false;
      }, 1600);
    }

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || form.nodeName !== 'FORM' || form.getAttribute('data-type') !== 'aito-add') return;
      if (typeof window.fetch !== 'function') return;

      event.preventDefault();

      var button = form.querySelector('.aito-featured__btn');
      var label = button ? button.getAttribute('data-aito-added') || '已加入購物車' : '';
      if (button) {
        button.disabled = true;
        button.classList.add('is-loading');
      }

      window
        .fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: new FormData(form),
        })
        .then(function (response) {
          if (!response.ok) throw new Error('cart-add-failed');
          return response.json();
        })
        .then(function (item) {
          if (button) button.classList.remove('is-loading');
          onDone(button, label);
          document.dispatchEvent(
            new CustomEvent('aito:cart-added', { detail: { item: item, form: form } })
          );
        })
        .catch(function () {
          if (button) {
            button.disabled = false;
            button.classList.remove('is-loading');
          }
          form.submit();
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
